module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-43.27bd770d.png";